import React, { useCallback } from 'react';
import type { ParamListBase } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import {
  TransparentModal,
  useSafeNavigation,
  useSafeRouteParams,
  useSafeRouter,
} from '@sg/garnish';

import { useIsExpoRouterEnabled } from '@order/shared/hooks';

import { useNavigateBack } from '../../navigation';
import { DeliveryOrderInFlightContent } from './DeliveryOrderInFlightContent';

export const DeliveryOrderInFlightScreen = () => {
  const isExpoRouterEnabled = useIsExpoRouterEnabled();
  const navigation =
    useSafeNavigation<NativeStackNavigationProp<ParamListBase>>();
  const router = useSafeRouter();
  const { orderId } = useSafeRouteParams<{ orderId?: string }>();
  const navigateBack = useNavigateBack();

  const handleClose = useCallback(() => {
    navigateBack();
  }, [navigateBack]);

  const handleOrderStatus = useCallback(() => {
    if (isExpoRouterEnabled) {
      router?.replace({
        pathname: '/order-status/[orderId]',
        params: { orderId: orderId ?? '' },
      });
      return;
    }

    navigation?.replace('OrderStatus', { orderId });
  }, [isExpoRouterEnabled, navigation, router, orderId]);

  return (
    <TransparentModal
      testID="delivery-order-in-flight"
      size="medium"
      onClose={handleClose}
    >
      <DeliveryOrderInFlightContent
        onClose={handleClose}
        onOrderStatus={handleOrderStatus}
      />
    </TransparentModal>
  );
};
